import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

const useInitialMount = (effect: () => any) => {
    useEffect(() => {
        try {
            const result = effect()
            if (result && typeof result.then === 'function') {
                Promise.resolve(result).catch(error => {
                    Sentry.captureException(error, { tags: { hook: 'useInitialMount' } })
                    throw error
                })
            }
        } catch (error) {
            Sentry.captureException(error, { tags: { hook: 'useInitialMount' } })
            throw error
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}

export default useInitialMount
